import styled from 'styled-components';
import breakpoints from '../breakpoints';

export const Wrapper = styled.div`
    background-color: ${({ backgroundColor }) => (backgroundColor || '#fff')};
    margin: 0 auto;
    max-width: 1600px;
    padding: ${({ padding }) => (padding || '20px 8px')};
    text-align: ${({ forceAlign }) => forceAlign || 'left'}
    width: 100%;

    @media ${breakpoints.small} {
        padding: ${({ padding }) => (padding || '40px 0')};
    }

    @media ${breakpoints.extraLarge} {
        padding: ${({ padding }) => (padding || '70px 0')};
    }
`;
